var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-group',{attrs:{"config":{ x: 0, y: 0 }}},[(['D1N01', 'D1N02', 'D1N03', 'D1N04', 'D1N05', 'D1N06', 'D1N07'].indexOf(_vm.product.typ) >= 0)?_c('div',[_c('v-image',{attrs:{"id":"okleina","config":{ image: _vm.okleinaimage, width: _vm.width, height: _vm.height, crop: { width: _vm.width * 2, height: _vm.height * 2, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"lewe","config":{ image: _vm.nl, y: _vm.grubosc, width: _vm.grubosc, height: _vm.height - 2 * _vm.grubosc, crop: { width: 90, height: 272, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"prawe","config":{ image: _vm.nl, x: _vm.width, height: _vm.height - 2 * _vm.grubosc, y: _vm.grubosc, width: _vm.grubosc, scaleX: -1, crop: { width: 82, height: 110, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"gora","config":{ image: _vm.nt, x: _vm.grubosc, height: _vm.grubosc, width: _vm.width - 2 * _vm.grubosc, crop: { width: 272, height: 90, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"dol","config":{ image: _vm.nt, x: _vm.grubosc, height: _vm.grubosc, scaleY: -1, y: _vm.height, width: _vm.width - 2 * _vm.grubosc, crop: { width: 272, height: 90, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"lewegora","config":{ image: _vm.nlt, width: _vm.grubosc, height: _vm.grubosc, crop: { width: 90, height: 90, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"lewedol","config":{ image: _vm.nlt, scaleY: -1, y: _vm.height, width: _vm.grubosc, height: _vm.grubosc, crop: { width: 90, height: 90, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"prawegora","config":{ image: _vm.nlt, x: _vm.width, height: _vm.grubosc, width: _vm.grubosc, scaleX: -1, crop: { width: 82, height: 90, x: 0, y: 0 } }}}),_c('v-image',{attrs:{"id":"prawedol","config":{
      image: _vm.nlt,
      x: _vm.width,
      height: _vm.grubosc,
      width: _vm.grubosc,
      scaleX: -1,
      scaleY: -1,
      y: _vm.height,
      crop: { width: 90, height: 90, x: 0, y: 0 },
    }}}),_c('v-image',{attrs:{"id":"tlo","config":{
      image: _vm.okleinaimage5,
      x: _vm.grubosc,
      y: _vm.height - _vm.grubosc,
      width: _vm.width - 2 * _vm.grubosc,
      height: _vm.height - 2 * _vm.grubosc,
      scaleY: -1,
      crop: {
        width: (_vm.width - 2 * _vm.grubosc) * 4,
        height: (_vm.height - 2 * _vm.grubosc) * 4,
        x: (_vm.grubosc + (500 - this.product.szerokoscnb2) / 4) * 4,
        y: 500 - this.product.wysokoscng + _vm.grubosc * 4,
      },
    }}}),_c('v-image',{attrs:{"id":"okleina2","config":{
      image: _vm.okleinaimage3,
      x: _vm.grubosc,
      y: _vm.grubosc,
      width: _vm.width - 2 * _vm.grubosc,
      height: _vm.height - 2 * _vm.grubosc,
    }}}),_c('v-line',{attrs:{"id":"lg","config":{
      points: [0, 0, _vm.grubosc, _vm.grubosc, _vm.width - _vm.grubosc, _vm.grubosc, _vm.width, 0, 0, 0, 0, _vm.height, _vm.grubosc, _vm.height - _vm.grubosc, _vm.width - _vm.grubosc, _vm.height - _vm.grubosc, _vm.width, _vm.height, _vm.width, 0],
      stroke: 'black',
      strokeWidth: 0.3,
    }}}),_c('v-rect',{attrs:{"id":"Obramówka","config":{ width: _vm.width, height: _vm.height, opacity: 0.15, fill: '#fff', x: 0, y: 0 }}})],1):_vm._e(),(['D1N08'].indexOf(_vm.product.typ) >= 0)?_c('div',[_c('v-image',{attrs:{"id":"okleina","config":{
      image: _vm.okleinaimage,
      x: _vm.width,
      y: -25 / 4,
      width: _vm.height,
      height: _vm.width,
      crop: { width: _vm.height * 2, height: _vm.width * 2, x: 10, y: 10 },
      rotation: 90,
    }}}),_c('v-line',{attrs:{"id":"lg","config":{
      points: [0, -25 / 4, _vm.width, -25 / 4, _vm.width, _vm.height - 25 / 4, 0, _vm.height - 25 / 4, 0, -25 / 4],
      stroke: 'black',
      strokeWidth: 0.5,
    }}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }